"use strict";
exports.__esModule = true;
exports.ResponseCode = void 0;
var ResponseCode;
(function (ResponseCode) {
    ResponseCode["OK"] = "OK";
    ResponseCode["UNKNOWN_METHOD_NAME"] = "UNKNOWN_METHOD_NAME";
    ResponseCode["ARG_DECODE_ERROR"] = "ARG_DECODE_ERROR";
    ResponseCode["RESULT_ENCODE_ERROR"] = "RESULT_ENCODE_ERROR";
    ResponseCode["HANDLER_RUNTIME_ERROR"] = "HANDLER_RUNTIME_ERROR";
    ResponseCode["NO_RESPONSE"] = "NO_RESPONSE";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
//# sourceMappingURL=types.js.map